import axios from 'axios'
import { cookieGet } from '@/common/cookie'
import { Message } from 'element-ui'
import { isPlainObject } from 'lodash'
import qs from 'qs'
import store from '@/store'

// 记录和显示错误
function errorLog(info) {
  // 显示提示
  Message({
    message: info,
    type: 'error',
    duration: 5 * 1000
  })
}


// 成功
function success() {
  // 显示提示
  Message({
    message: cookieGet('language') == 'zh-CN' ? '成功' : 'success',
    type: 'success',
    duration: 3 * 1000
  })
}

console.log('app', process.env.NODE_ENV === 'production' ? { name: process.env.VUE_APP_NAME, build: process.env.NODE_ENV, version: process.env.VUE_APP_MYVERSION } : process.env)
// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 1000 * 180,
  withCredentials: true
})

/**
 * 请求拦截
 */
service.interceptors.request.use(config => {
  config.headers['language'] = cookieGet('language') == 'zh-CN' ? 'chs' : 'eng'
  // config.headers['Content-type'] = 'application/json; charset=utf-8'
  // config.headers['token'] = cookieGet('token') || ''
  var token = cookieGet('token') || ''
  // 默认参数
  var defaults = {}
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get' || config.method === 'delete' || config.data.noQs) {
    config.params = {
      token: token,
      ...config.params,
      ...{ '_t': new Date().getTime() }
    }
  } else {
    config.data = {
      token: token,
      ...config.data
    }

  }
  if (isPlainObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params
    }
  }
  if (isPlainObject(config.data)) {
    config.data = {
      ...defaults,
      ...config.data
    }
    // if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
    if (!config.data.noQs) {
      config.data = qs.stringify(config.data)
      // } else { //Ivent
      //   config.data.token = token
    }
    // }
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
service.interceptors.response.use(response => {
  if (response.data.code === "401" || response.data.code === "10001") {
    store.dispatch('d2admin/account/logout')
    return Promise.reject(response.data.message)
  } else if (response.data.code !== "0") {
    errorLog(response.data.message)
    return Promise.reject(response.data.message)
  } else {
    if (response.config.method !== "get" && !response.config._silent) {
      success()
    } else {

      fetch(`${process.env.VUE_APP_API}/v1/sys/version`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(response.data.data)
      }).then(res => res.json()).then(res => {
        console.log('server', res)
      })

    }
    return response.data;
  }
}, error => {
  errorLog(error.message)
  return Promise.reject(error)
})

export default service
